import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { InputMi } from '@design-system-etat/dsfr-react';
import PropTypes from 'prop-types';
import loadCaptcha from './captcha-lib';
import './Captcha.css';
import refreshImage from './img/refresh.svg';
import audioImage from './img/audio.svg';
import { TAILLE_CAPTCHA } from '../../constants/contraintes.constants';
import { getMessageErreurChampManquant } from '../../utils/utils';

const Captcha = ({ setInfoCaptcha }) => {
    useEffect(() => {
        loadCaptcha();
    }, []);

    const { register, formState, getValues, watch } = useForm({
        mode: 'onChange',
    });

    useEffect(() => {
        setInfoCaptcha({ code: getValues('code') });
    }, [watch('code')]);

    return (
        <div className="mi-captcha">
            <div className="mi-captcha-img">
                <img className="mi-captcha-image" alt="captcha" src="" />
                <div>
                    <img
                        className="mi-captcha-img-right mi-captcha-refresh"
                        title="Générer un nouveau captcha"
                        alt="Nouveau captcha"
                        width="32"
                        src={refreshImage}
                    />
                    <img
                        className="mi-captcha-img-right mi-captcha-audio-play"
                        title="Version audio captcha"
                        width="32"
                        alt="captcha version audio"
                        src={audioImage}
                    />
                </div>
                <audio className="mi-captcha-audio">
                    <track kind="captions" />
                </audio>
            </div>
            <div>
                <InputMi
                    label="Code"
                    type="text"
                    required
                    minLength={TAILLE_CAPTCHA}
                    maxLength={TAILLE_CAPTCHA}
                    {...register('code', {
                        required: getMessageErreurChampManquant('code'),
                    })}
                    error={formState.errors ? formState.errors.code : null}
                />
            </div>
        </div>
    );
};
Captcha.propTypes = {
    setInfoCaptcha: PropTypes.func.isRequired,
};

export default Captcha;
